var Header = (function () {

    var $ = require('jquery');
    var self = {};

    self.$subMenu = $('.has-children');

    self.init = function () {

        self.$subMenu.on('click', function (ev) {
            ev.preventDefault();

            var $parentListItem = $(this).closest('li');

            //  Open/close current
            if ($parentListItem.hasClass('selected')) {
                $parentListItem.removeClass('selected');
            } else {

                //  Close all active
                $('.primary-menu').find('.menu-item-has-children').removeClass('selected');

                $(this).closest('li').addClass('selected');
            }


        });

    };

    return self;

}());

module.exports = Header;
